import { jsx as _jsx } from "react/jsx-runtime";
import { Label } from '@cancercentrum/rcc-bootstrap';
export const ValidationLabel = ({ row })=>{
    const errors = row.getErrors().reduce((reduction, regvar)=>{
        regvar.$errors.forEach((x)=>{
            if (!x.isFatal) {
                reduction.warnings.push(x);
            } else {
                reduction.errors.push(x);
            }
        });
        return reduction;
    }, {
        errors: [],
        warnings: []
    });
    if (errors.errors.length) {
        return /*#__PURE__*/ _jsx(Label, {
            bsStyle: "danger",
            children: errors.errors.length + errors.warnings.length
        });
    }
    if (errors.warnings.length) {
        return /*#__PURE__*/ _jsx(Label, {
            bsStyle: "warning",
            children: errors.warnings.length
        });
    }
    return null;
};
